<template>
  <div>
    <div>
      <CheckoutItem v-for="item in checkoutItems" :item="item" :key="item.name" />
    </div>
    <v-container>
      <v-row>
        <v-col
          :xs="12"
          :md="6"
          :class="{
            'pa-0': !$vuetify.breakpoint.smAndUp
          }"
        >
          <PointRedemption :point="point" :currency="orderSummary.currency" />
        </v-col>
        <v-col :xs="12" :md="6" class="d-flex flex-column">
          <v-simple-table class="checkout-summary mt-10 secondary--text text--lighten-2">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>{{ $t('label.merchandiseTotal') }}:</td>
                  <td align="right" class="pr-0">{{ orderSummary.currency }}</td>
                  <td align="right" class="pl-0 amount">{{ formatAmount(orderSummary.subtotal) }}</td>
                </tr>
                <tr class="primary--text text--lighten-1" v-if="orderSummary">
                  <td>{{ $t('label.pointRedemption') }}:</td>
                  <td align="right" class="pr-0">{{ orderSummary.currency }}</td>
                  <td align="right" class="pl-0 amount">{{ formatAmount(orderSummary.point_redemption_amount) }}</td>
                </tr>
                <tr>
                  <td>{{ $t('label.tax') }}{{ orderSummary.tax_rate ? `(${orderSummary.tax_rate})` : '' }}:</td>
                  <td align="right" class="pr-0">{{ orderSummary.subtotal_with_tax > orderSummary.subtotal ? orderSummary.currency : '' }}</td>
                  <td align="right" class="pl-0 amount">{{ orderSummary.subtotal_with_tax > orderSummary.subtotal ? formatAmount(orderSummary.tax_amount) : '-' }}</td>
                </tr>
                <tr>
                  <td colspan="3"><v-divider class="my-3" /></td>
                </tr>
                <tr>
                  <td>{{ $t('label.subtotal') }}:</td>
                  <td align="right" class="pr-0">{{ orderSummary.currency }}</td>
                  <td align="right" class="pl-0 amount">{{ formatAmount(orderSummary.subtotal_with_tax) }}</td>
                </tr>
                <tr>
                  <td>{{ $t('label.deliveryFee') }}:</td>
                  <td align="right" class="pr-0">{{ Number(shippingFee) ? orderSummary.currency : '' }}</td>
                  <td align="right" class="pl-0 amount">{{ Number(shippingFee) ? formatAmount(shippingFee) : shippingFee }}</td>
                </tr>
                <tr>
                  <td colspan="3"><v-divider class="my-3" /></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>{{ $t('label.totalPayment') }}:</td>
                  <td align="right" class="pr-0">{{ orderSummary.currency }}</td>
                  <td align="right" class="pl-0">{{ formatAmount(orderSummary.total) }}</td>
                </tr>
              </tfoot>
            </template>
          </v-simple-table>
          <v-spacer />
          <div class="primary lighten-1 white--text py-4 px-6 mt-auto rounded">
            <div class="d-flex justify-space-between mb-0 font-weight-bold">
              <span>{{ $t('label.totalPointsEarned') }}</span>
              <span>{{ point.total_point_earn }}</span>
            </div>
            <p class="text-caption">*{{ $t('hint.totalPointsEarned', { noOfDay: orderCompletedDay }) }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { uiHelper } from '@/utils'

import CheckoutItem from '@/components/checkout/CheckoutItem.vue'
import PointRedemption from './PointRedemption.vue'

export default {
  components: {
    CheckoutItem,
    PointRedemption
  },

  props: ['checkoutItems', 'orderSummary', 'voucherOnlyCart', 'orderCompletedDay'],

  computed: {
    ...mapState('order', ['point']),
    shippingFee() {
      if (this.voucherOnlyCart) {
        return '-'
      }
      return this.orderSummary.shipping || this.$t('label.free')
    }
  },
  created() {
    this.getShipping()
  },
  methods: {
    ...mapActions('order', ['getShipping']),
    formatAmount(amount) {
      return uiHelper.priceFormatter(amount)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .checkout-summary {
  td {
    font-size: 1.1rem !important;
  }

  tr:hover {
    background: unset !important;
  }

  tr > td {
    height: unset !important;
    border-bottom: unset !important;
  }

  .amount {
    font-weight: bold;
  }

  tfoot {
    font-weight: bold;
    td {
      color: var(--v-secondary-lighten2) !important;
    }
  }
}
</style>
